<template>  
	     	<el-submenu :index="model.path" v-if="model.children.length>0" >
					<template slot="title" ><i :class="model.icon"></i>{{model.title}}</template>		          
					    <menuitems v-for="(cl,index) in model.children" :key="index" :model="cl" ></menuitems>   
				</el-submenu>
				<el-menu-item :index="model.path" v-else-if="model.children.length==0"><i :class="model.icon"></i>{{model.title}}</el-menu-item>
				
</template>

<script>
export default {
  name: 'menuitems',
  props:['model']
}
</script>





// WEBPACK FOOTER //
// MenuItems.vue?664e10ba